module.exports = __webpack_public_path__ + "img/fre_logo.7cdc4413.png";